import { ResponseError } from 'superagent';

const isResponseError = (e: unknown): e is ResponseError => (e as ResponseError)?.response !== undefined;
export default isResponseError;
